import InboxHeader from "./InboxHeader";
export default InboxHeader;